"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var activityListApi = _interopRequireWildcard(require("@/api/activityListApi"));
var _UserForms = _interopRequireDefault(require("./UserForms.vue"));
var _pageCache = require("@/utils/pageCache");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'Skin',
  components: {
    UserForms: _UserForms.default
  },
  data: function data() {
    return {
      constants: this.$constants,
      listPram: {
        title: '',
        status: '',
        page: 1,
        limit: 20
      },
      listData: {
        list: [],
        total: 0
      },
      listLoading: true,
      tableHeaderStyle: {
        backgroundColor: '#f5f7fa',
        color: '#606266',
        fontWeight: 'bold',
        height: '50px'
      },
      statusOptions: [{
        value: '1',
        label: '启用'
      }, {
        value: '0',
        label: '禁用'
      }]
    };
  },
  mounted: function mounted() {
    this.handlerGetListData();
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      return (0, _pageCache.refreshOnCacheReentry)(vm, function () {
        return vm.handlerGetListData(vm.listPram);
      });
    });
  },
  methods: {
    // 获取商品类型标签
    getProductTypeLabel: function getProductTypeLabel(type) {
      switch (type) {
        case 0:
          return '所有商品';
        case 1:
          return '指定SKU';
        case 2:
          return '指定分类';
        default:
          return '未配置';
      }
    },
    // 获取商品标签类型
    getProductTagType: function getProductTagType(type) {
      switch (type) {
        case 0:
          return '';
        case 1:
          return 'warning';
        case 2:
          return 'primary';
        default:
          return 'info';
      }
    },
    handerAdd: function handerAdd() {
      this.$router.push('/applet/skinForm/editForm/0');
    },
    handerEdit: function handerEdit(id) {
      this.$router.push("/applet/skinForm/editForm/".concat(id));
    },
    openRead: function openRead(id) {
      var _this = this;
      // 获取表单详情，然后打开用户表单数据弹窗
      this.listLoading = true;
      activityListApi.detailSkinForm({
        id: id
      }).then(function (res) {
        _this.listLoading = false;
        _this.$refs.UserFormsRef.initOpen(res);
      }).catch(function () {
        _this.listLoading = false;
        _this.$message.error('获取表单详情失败');
      });
    },
    // 搜索
    handerSearch: function handerSearch() {
      this.listPram.page = 1;
      this.handlerGetListData();
    },
    // 列表分页查询
    handlerGetListData: function handlerGetListData() {
      var _this2 = this;
      var pram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.listPram;
      this.listLoading = true;
      activityListApi.getSkinFormList(_objectSpread({}, pram)).then(function (data) {
        _this2.listData = data;
        _this2.listLoading = false;
      }).catch(function () {
        _this2.listData = {
          list: [],
          total: 0
        };
        _this2.listLoading = false;
      });
    },
    // 修改状态
    handleStatus: function handleStatus(row) {
      var _this3 = this;
      this.listLoading = true;
      activityListApi.changeStateSkinForm({
        id: row.id
      }).then(function (data) {
        _this3.$message.success('操作成功');
        _this3.listLoading = false;
        _this3.handlerGetListData();
      }).catch(function () {
        _this3.listLoading = false;
        row.status = row.status === 1 ? 0 : 1;
      });
    },
    // 删除
    handleDelete: function handleDelete(row) {
      var _this4 = this;
      this.$confirm('确定删除当前数据', '提示').then(function (result) {
        _this4.listLoading = true;
        activityListApi.deleteSkinForm({
          id: row.id
        }).then(function (data) {
          _this4.$message.success('删除数据成功');
          _this4.listLoading = false;
          _this4.handlerGetListData();
        }).catch(function () {
          _this4.listLoading = false;
        });
      });
    },
    // 翻页
    handleSizeChange: function handleSizeChange(val) {
      this.listPram.limit = val;
      this.listPram.page = 1;
      this.handlerGetListData();
    },
    // 翻页
    handleCurrentChange: function handleCurrentChange(val) {
      this.listPram.page = val;
      this.handlerGetListData();
    }
  }
};